import Action from '../base/action';

class LoadViewpoint extends Action {
    position;
    quaternion;
    viewpointId;
    viewpointApplyMode;

    constructor(props) {
        super(props);
        this.position = props.position;
        this.quaternion = props.quaternion;
        this.viewpointId = props.viewpointId;
        this.viewpointApplyMode = props.viewpointApplyMode || '2D';
    }

    async execute({training}) {
        if ((isVRModeEnabled() || isMobileARModeEnabled()) && this.viewpointApplyMode === '2D') {
            return;
        }
        const viewpoint = training.resources[this.viewpointId];
        let calculatedViewpointValues;
        if (viewpoint && viewpoint.viewpointObj) {
            calculatedViewpointValues = ViewPointManager.getCameraConfiguration(parseData(viewpoint.viewpointObj));
        }

        const positionValue = this.position ? this.position : viewpoint.position ? viewpoint.position : getArrayFromObj(calculatedViewpointValues.position);
        const quaternionValue = this.quaternion ? this.quaternion : viewpoint.quaternion ? viewpoint.quaternion : getArrayFromObj(calculatedViewpointValues.orientation);
        iq3Camera.zoomCamera(1);
        ViewPointManager.setViewpoint(wv.registeredID, new THREE.Vector3(...positionValue), new THREE.Quaternion(...quaternionValue), true);

        function getArrayFromObj(obj) {
            return Object.values(obj).filter(val => {
                return typeof val !== 'boolean';
            });
        }

        function parseData(viewpointData) {
            return {
                position: new THREE.Vector3(
                    parseFloat(viewpointData.cameraPosition.x),
                    parseFloat(viewpointData.cameraPosition.y),
                    parseFloat(viewpointData.cameraPosition.z)
                ),
                orientation: new THREE.Quaternion(
                    parseFloat(viewpointData.cameraOrientation.x),
                    parseFloat(viewpointData.cameraOrientation.y),
                    parseFloat(viewpointData.cameraOrientation.z),
                    parseFloat(viewpointData.cameraOrientation.w)
                ),
                attachedVolumeName: viewpointData.attachedVolumeName
            };
        }
    }
}

export default LoadViewpoint;
